import PropTypes from 'prop-types';
import { FaEraser } from 'react-icons/fa';
import  {EditButton} from './StyledComponents.jsx';

export const BotonBorrar = ({ Borrar, row }) => {
  return (
    <EditButton
      type="button"
      onClick={() => Borrar(row)}
      data-tooltip-id="tooltiparriba"
      data-tooltip-content="Borrar"
    >
      <FaEraser />
    </EditButton>
  );
};

BotonBorrar.propTypes = {
  Borrar: PropTypes.func.isRequired,
  row: PropTypes.any
};